import React, { useEffect, useState } from "react";

export default function PrinterSettingsPage() {
  const [printers, setPrinters] = useState([]);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!window.electronAPI) {
        alert("この設定画面はElectronアプリでのみ使用できます");
        return;
      }
      const p = await window.electronAPI.getPrinters();
      const c = await window.electronAPI.getPrintConfig();
      setPrinters(p);
      setConfig(c);
    };
    load();
  }, []);

  const handleChange = (key, value) => {
    setConfig(prev => ({ ...prev, [key]: value }));
  };

  const handleChooseExcelFolder = async () => {
    try {
      const folder = await window.electronAPI.selectDailyCashExcelFolder();
      if (folder) handleChange('dailyCashExcelFolder', folder);
    } catch (error) {
      alert(`Excel保存先の選択に失敗しました：${error.message}`);
    }
  };

  const handleSave = async () => {
    try {
      // 空欄ならデフォルトを使う。Excel書き出し時にも同じチェックをする。
      const safeName = String(config.dailyCashExcelFileName ?? '2階締め').trim() || '2階締め';
      const baseName = safeName.replace(/\.xlsx$/i, '').trim();
      if (!baseName || /[\\/:*?"<>|]/.test(baseName) || /[. ]$/.test(baseName)) {
        alert('Excelファイル名に使用できない文字が含まれています。');
        return;
      }
      await window.electronAPI.savePrintConfig({
        ...config,
        dailyCashExcelFileName: baseName,
      });
      alert("保存しました");
    } catch (error) {
      alert(`設定の保存に失敗しました：${error.message}`);
    }
  };

  if (!config) return <div>読み込み中...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>プリンター設定</h2>
      {[
        ["通常ラベル", "printDeviceName"],
        ["QRラベル", "printDeviceNameQr"],
        ["販売ノート", "printDeviceNameDefault"],
        ["レシート", "printDeviceNameReceipt"],
      ].map(([label, key]) => (
        <div key={key} style={{ marginBottom: 10 }}>
          <label style={{ width: 150, display: "inline-block" }}>{label}</label>
          <select
            value={config[key] || ""}
            onChange={(e) => handleChange(key, e.target.value)}
          >
            <option value="">未設定</option>
            {printers.map(p => (
              <option key={p.name} value={p.name}>{p.name}</option>
            ))}
          </select>
        </div>
      ))}

      {/* ここで日次精算表のExcel保存先フォルダーを設定 */}
      <div style={{ margin: '20px 0', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <label style={{ width: 150 }}>精算表Excel保存先</label>
        <input
          type="text"
          readOnly
          value={config.dailyCashExcelFolder || ''}
          placeholder="保存先フォルダーを選んでください"
          style={{ minWidth: 280, flex: '1 1 280px', padding: 6 }}
        />
        <button type="button" onClick={handleChooseExcelFolder}>
          フォルダー選択
        </button>
      </div>
      {/* Excelのファイル名は固定。日付・レジIDをファイル名に追加しない */}
      <div style={{ margin: '12px 0 20px', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <label htmlFor="dailyCashExcelFileName" style={{ width: 150 }}>精算表Excelファイル名</label>
        <input
          id="dailyCashExcelFileName"
          type="text"
          value={config.dailyCashExcelFileName ?? '2階締め'}
          onChange={(e) => handleChange('dailyCashExcelFileName', e.target.value)}
          placeholder="2階締め"
          style={{ minWidth: 260, flex: '1 1 260px', padding: 6 }}
        />
        <span>.xlsx</span>
      </div>
      <p style={{ fontSize: 13, color: '#aaa', lineHeight: 1.5 }}>
        既定の保存名は「2階締め.xlsx」です。指定した同名ファイルを日付・レジに関係なく上書きします。
        Excel内は「精算集計」のセル位置を固定し、買取・仕入・経費・移動の増減は「変動明細」シートで管理します。
      </p>

      <button onClick={handleSave}>保存</button>
    </div>
  );
}
